import { InjectionToken } from '@angular/core';

import { Task } from '../models/task.interface';

export const TASK_DATA = new InjectionToken<Task>('TASK_DATA');
